import {NgModule} from '@angular/core';
import {SearchResultsComponent} from '@app/shared/components/search-results/search-results.component';
import {SharedModule} from '@app/shared/shared.module';
import {SearchEffects} from '@app/shared/state/search/search.effects';
import {EffectsModule} from '@ngrx/effects';

@NgModule({
  imports: [SharedModule, SearchResultsComponent, EffectsModule.forFeature([SearchEffects])],
  exports: [SearchResultsComponent],
})
export class SearchModule {}
